module.exports = __webpack_public_path__ + "img/orangeSearchIcon.b2365326.svg";